import Layout from "./views/Layout";
import store from "@/store";

const routes = [
    {
        path: "/management",
        component: Layout,
        beforeEnter: checkUserLogin,
        name: "ManagementDashboard",
        children: [
            {
                path: '',
                redirect: () => {
                    const theme = store.state.userInfo?.corporate?.theme;
                    return theme === 'assessment' ? '/assessment' : '/management/video';
                }
            },
            {
                path: 'billing',
                component: () => import('@/module_dashboard/views/CorporateBillingHistory.vue'),
                name: 'AdminBillingHistory',
                beforeEnter: checkUserLogin
            },
            {
                path: "microsite",
                component: () => import("../views/SMBSignIn/Microsite.vue"),
                name: 'UpdateProfile'
            },
            {
                path: "admin-billing",
                component: () => import("./views/AdminBilling.vue"),
                name: 'AdminBilling'
            },
            {
                path: 'playback/:sessionId',
                component: () => import("./views/Playback.vue"),
                name: 'playback'
            },
            {
                path: 'conditions',
                component: () => import('./views/conditions.vue'),
                beforeEnter: checkSubscription,
                name: 'conditions',
            },
            {
                path: "video/add",
                component: () => import("./views/VideoUpload.vue"),
                beforeEnter: checkSubscription,
                name: 'VideoUpload'
            },
            {
                path: 'analytics',
                component: () => import("./views/Analytics/Index"),
                name: "AnalyticsSection",
                children: [
                    {
                        path: '',
                        redirect: '/management/analytics/dashboard'
                    },
                    {
                        path: 'dashboard',
                        component: () => {
                            return isPhysio() ?
                            import("./views/Analytics/PhysioDashboard.vue") :
                            import("./views/Analytics/Dashboard.vue");
                        },
                        name: 'AnalyticsDashboard'
                    },
                    {
                        path: 'reports',
                        component: () => import("./views/Analytics/ReportsUser.vue"),
                        name: 'AnalyticsReports'
                    },
                    {
                        path: 'patient-report',
                        component: () => import("./views/Analytics/PatientReport.vue"),
                        name: 'AnalyticsReports'
                    },
                    {
                        path: 'patient-report-details',
                        component: () => import("./views/Analytics/PatientReportDetails.vue"),
                        name: 'AnalyticsReports'
                    },
                    {
                        path : "reports-ai",
                        component : ()=> import("./views/Analytics/AiAdminReport.vue"),
                        name: "AiAdminReport"
                    }
                    // {
                    //     path: 'reports-user',
                    //     component: () => import("./views/Analytics/ReportsUser.vue"),
                    //     name: 'AnalyticsReportsUser'
                    // }
                ]
            },
            {
                path: 'video',
                component: () => import("./views/Video-Management/Index.vue"),
                name: 'VideoManagement',
                children: [
                    {
                        path: '',
                        redirect: '/management/video/library'
                    },
                    {
                        path: 'library',
                        component: () => import('./views/Video-Management/VideoLibrary.vue'),
                        name: 'VideoManagementLibrary'
                    },
                    {
                        path: 'list',
                        component: () => import('./views/Video-Management/VideoList.vue'),
                        name: 'VideoManagementList'
                    },
                    {
                        path: 'edit',
                        component: () => import('./views/Video-Management/VideoEdit.vue'),
                        name: 'edit'
                    },
                    {
                        path: 'challenges',
                        component: () => import('./views/Video-Management/Challenges.vue'),
                        name: 'AnalyticsChallenges'
                    },
                    {
                        path: 'program',
                        component: () => import("./views/Video-Management/Program"),
                        name: 'AnalyticsProgram'
                    },
                    {
                        path: 'assignment',
                        component: () => import("./views/Video-Management/AssignProgramChallenge"),
                        name: 'AssignProgramChallenge',
                    },
                    {
                        path: 'create-assign/:id?',
                        component: () => import("./views/Video-Management/CreateAssignProgram"),
                        name: 'CreateAssignProgram',
                    }
                ]
            },
            {
                path: "user",
                component: () => import("./views/User/Index"),
                name: "UserManagement",
                children: [
                    {
                        path: '',
                        redirect: '/management/user/users'
                    },
                    {
                        path: 'users',
                        component: () => import("./views/User/Users"),
                        name: "UsersManagement"
                    },
                    {
                        path: 'teams',
                        component: () => import("./views/User/Teams"),
                        name: "TeamsManagement"
                    },
                    {
                        path: ':email',
                        component: () => import("./views/User/UserProfile"),
                        name: "UserProfileInfo"
                    }
                ]
            },
            {
                path: "workout",
                component: () => import("./views/Workouts"),
                name: "WorkoutManagement"
            },
            {
                path: "notifications", 
                component: () => import("./views/Notifications.vue"),
                beforeEnter: checkNotificationAccess,
                name: "Notifications"
              },
              {
                path: "notifications/add", 
                name: "AddNotification",
                beforeEnter: checkNotificationAccess,
                component: () => import("./views/AddNotification.vue"),
              },
              {
                path : "achievement",
                component:()=> import("./views/Achievement/Index"),
                name : "AchievementManagement"
            }
        ]
    },
];

export default routes;

export async function checkUserLogin(to, from, next) {
    const userInfo = localStorage.getItem("userInfo");
    if (!userInfo) {
        next("/");
        return;
    }
    const userInfoObj = JSON.parse(userInfo);
    if (userInfoObj.hasOwnProperty('isAnonymousUser') && userInfoObj.isAnonymousUser) {
        next("/");
        return;
    }
    if (!["CorporateHR", "Super Admin"].includes(userInfoObj.role)) {
        next("/");
        return;
    }
    const currentUser = userInfoObj;
    const corporate = currentUser?.corporate;
    if (corporate) {
        // check if profile completed when corporate has completeProfileMandatory true
        const completeProfileMandatory = corporate.config?.completeProfileMandatory === true;
        const isProfileCompleted = currentUser.profile_completed === true;
        if (completeProfileMandatory && !isProfileCompleted && currentUser.role == 'Enduser')
          return next({ name: "Complete Profile" });
    }
    next();
}

function isPhysio() {
    const userInfo = (JSON.parse(localStorage.getItem("userInfo")));
    return userInfo?.corporate?.theme === 'physiotherapy'
}

async function checkSubscription(to, from, next) {
    const userInfo = localStorage.getItem("userInfo");
    const userInfoObj = JSON.parse(userInfo);
    const subscription = userInfoObj?.corporate?.subscription;
    if (!subscription || subscription.is_free || !subscription.is_valid) {
        next("/subscription-plans");
        return;
    }
    next();
}

async function checkNotificationAccess(to, from, next){
    const userInfo = localStorage.getItem("userInfo");
    const userInfoObj = JSON.parse(userInfo);
    const showNotifications = !!userInfoObj?.corporate?.config?.showNotifications;
    
    if(showNotifications){
        next()
    }
    else{
        next()
    }
}

async function checkTheme(to, from ,next){
    const userInfo = localStorage.getItem("userInfo");
    const userInfoObj = JSON.parse(userInfo);
    if(userInfoObj?.corporate?.theme === "physiotherapy" ){
        next();
    }
    next("/")
}